import { gql } from "@apollo/client";

export const GET_RECURSIVE_FAQ_RESULTS = (ids: string, preview: boolean) => `
query {
    faqCollection(
        preview: ${preview}
        where: { sys: { id_in: [${ids}] } }
        limit: 10
      ) {
        items {
          question
          answer {
            json
            links {
              entries {
                hyperlink {
                  ... on Page {
                    sys {
                      id
                    }
                    slug
                    content {
                      __typename
                    }
                  }
                  ... on FileBlock {
                    sys {
                      id
                    }
                    imageVaultFile
                    metaData
                    __typename
                  }
                }
              }
            }
          }
          contentfulMetadata {
            concepts {
              id
            }
          }
          audienceCollection(limit:20) {
            items {
              audianceId
            }
          }
          sys {
            id
          }
          __typename
        }
      }
}`;

export const GET_FAQLIST_QUERY_RESULT = gql`
  query RecursiveFAQResult {
    faqCollection {
      items {
        question
        answer {
          json
          links {
            entries {
              hyperlink {
                ... on Page {
                  sys {
                    id
                  }
                  slug
                  content {
                    __typename
                  }
                }
                ... on FileBlock {
                  sys {
                    id
                  }
                  imageVaultFile
                  metaData
                  __typename
                }
              }
            }
          }
        }
        audienceCollection(limit: 20) {
          items {
            audianceId
          }
        }
        sys {
          id
        }
        __typename
      }
    }
  }
`;
